import http from '@/lib/http'
import { useMutation } from '@tanstack/react-query'

export type PrescriberFanWorkflowRequest = {
  orderItemHash: string
  content: string
  presetId?: string
  presetName?: string
  presetCategory?: string
  contentEdited?: boolean
}

export type PrescriberFanWorkflowResponse = unknown

async function triggerPrescriberFanWorkflow(
  payload: PrescriberFanWorkflowRequest
): Promise<PrescriberFanWorkflowResponse> {
  return (await http.post('/workflows/prescriber-fan/', payload)) as PrescriberFanWorkflowResponse
}

export function usePrescriberFanWorkflow() {
  return useMutation({
    mutationFn: triggerPrescriberFanWorkflow
  })
}
